import type { RootState } from '@core/Store'

export const selectLastDepositError = (state: RootState) => {
  return state.quickDeposit.lastDepositError
}

export const selectIsBusy = (state: RootState) => state.quickDeposit.depositStatus !== 'idle'
